<template>
  <div>
    <applicability-window
      :part-number="applicabilityWin.partNumber"
      :show="applicabilityWin.isVisible"
      @hide="applicabilityWin.isVisible = false"
    ></applicability-window>

    <v-data-table
      :loading="loading"
      :disabled="loading"
      dense
      :headers="[
        { text: $t('common.part'), value: 'brand', class: 'text-no-wrap' },
        { text: $t('common.title'), value: 'name', class: 'text-no-wrap' },
        {
          text: $t('common.supplier'),
          value: 'supplier',
          align: 'center',
          class: 'text-no-wrap',
        },
        {
          text: $t('common.delivery_time'),
          value: 'delivery_time',
          align: 'right',
          class: 'text-no-wrap',
        },
        {
          text: $t('common.amount'),
          value: 'amount',
          align: !isCalculation?'center':'end',
          width: '200px',
          class: 'text-no-wrap',
        },
        {
          text: $t('common.price'),
          value: 'price',
          align: 'right',
          class: 'text-no-wrap',
        },
        { text: $t('common.total_sum'), class: 'text-no-wrap', align: 'right', },
      ]"
      :items="items"
      :id="id"
      :height="height"
      hide-default-footer
      class="ma-0 multicarttable rounded-0"
      :options="{
                    itemsPerPage: 1000
                  }"
    >
      <template v-slot:item="props">
        <!----->
        <tr class="no-zebra">
          <td class="text-left">

            <span
              class="text-no-wrap d-block"
              :style="getStyleApplicable(props.item.order_check_result)"
              :title="getTextApplicable(props.item.order_check_result)"
            >
                          <v-progress-circular
                              size="12"
                              class="mr-1"
                              width="2"
                              indeterminate
                              color="primary"
                              :title="$t('order_check.checking_in_process')"
                              v-if="
                defaultCart &&
                defaultCart.order_check_status !== 'ready' &&
                defaultCart.order_check_id
              "
                          />
              <v-btn
                class="d-inline-block"
                text
                fab
                x-small
                rounded
                inlist=""
                max-width="16"
                max-height="16"
                :title="$t('applicabilityWindow.applicability')"
                @click="
                  applicabilityWin.partNumber =
                    props.item.crossed_from_part_number ||
                    props.item.part_number;
                  applicabilityWin.isVisible = true;
                "
              >
                <v-icon x-small>$applicability</v-icon>
              </v-btn>
              {{ props.item.brand }} {{ props.item.part_number }}
            </span>
            <span
              class="text-caption mb-0 d-inline-block"
              v-if="
                props.item.crossed_from_brand &&
                props.item.part_number !==
                  props.item.crossed_from_part_number &&
                props.item.brand != props.item.crossed_from_brand
              "
            >
              <span class="text-no-wrap d-inline-block">{{
                $t("viewOrdersForm.crossed_from")
              }}</span>
              <span class="text-no-wrap">{{
                props.item.crossed_from_brand.toLocaleUpperCase() +
                " " +
                props.item.crossed_from_part_number
              }}</span>
            </span>
          </td>
          <td class="text-left">{{ props.item.name }}</td>
          <td class="text-center">
            <span v-if="!props.item.is_dummy">{{
              props.item.supplier_name
            }}</span>
          </td>
          <td class="text-right">
            <span v-if="!props.item.is_dummy">{{
              props.item.delivery_time
            }}</span>
          </td>
          <td class="text-center">
            <v-container v-if="!isCalculation" class="justify-center d-flex" style="width: 100px">
              <v-btn
                v-if="props.item.is_dummy == 1"
                elevation="0"
                @click="$store.dispatch('cart/removeFromCart', props.item)"
                fab
                x-small
              >
                <v-icon x-small>$trash</v-icon>
              </v-btn>
              <v-row
                class="mx-0"
                justify="center"
                no-gutters
                v-if="!props.item.is_dummy"
              >
                <v-col class="pa-0" v-if="!isCalculation">
                  <v-btn
                    max-width="17"
                    max-height="17"
                    outlined
                    color="pink darken-1"
                    fab
                    x-small
                    @click="$store.dispatch('cart/removeFromCart', props.item)"
                    >-</v-btn
                  >
                </v-col>
                <v-col class="pa-0">
                  <edit-value-menu
                      :item="props.item"
                      :field-name="'amount'"
                      @update="(item)=>{props.item=item;cartItemUpdate(props.item)}"
                      :disabled=" ! (props.item.nomenclature &&
                          props.item.nomenclature.unit_of_measurement &&
                          props.item.nomenclature.unit_of_measurement.is_divisible &&
                          props.item.nomenclature.unit_of_measurement.is_divisible === 1) || ! isEnabledStorageV2 || isCalculation"
                  />
                </v-col>
                <v-col class="pa-0" v-if="!isCalculation">
                  <v-btn
                    max-width="17"
                    max-height="17"
                    outlined
                    color="success"
                    fab
                    x-small
                    @click="$store.dispatch('cart/addToCart', {...props.item, is_increase:true})"
                    >+</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
            <v-else>
              <div class="text-right">
                {{props.item.amount}}
              </div>
            </v-else>
          </td>
          <td class="text-right">
            <span v-if="!props.item.is_dummy && isCalculation">
               {{ formatCurrency(props.item.price) }}
            </span>
            <span v-if="!props.item.is_dummy && !isCalculation">
              <v-menu
                v-model="priceMenu[props.item.id]"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-x
              >
                <template v-slot:activator="{ on }">
                  <a v-on="on" @click="priceTmp = props.item.price" class="text-no-wrap">
                    {{ formatCurrency(props.item.price) }}
                  </a>
                </template>

                <v-card>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field
                          :placeholder="$t('common.price')"
                          v-model="priceTmp"
                          required
                          type="numeric"
                          :rules="[
                            (v) =>
                              !!v ||
                              $t('form.validationErrors.field_is_required'),
                          ]"
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text @click="priceMenu[props.item.id] = false">{{
                      $t("common.cancel")
                    }}</v-btn>
                    <v-btn
                      color="primary"
                      text
                      @click="
                        priceMenu[props.item.id] = false;
                        props.item.price = priceTmp;
                        cartItemUpdate(props.item);
                      "
                    >
                      {{ $t("common.save") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </span>
            <v-btn
              v-if="props.item.is_dummy == 1"
              color="green"
              class="white--text"
              elevation="0"
              @click="
                goToSearchWithPart(props.item.brand, props.item.part_number)
              "
            >
              {{ $t("common.get_price_for_item") }}
            </v-btn>
            <div class="text-right" id="goToSearchWithPart" v-if="isVisible"></div>
          </td>
          <td class="text-right text-no-wrap">
            <span v-if="!props.item.is_dummy" class="text-no-wrap">
              {{ formatCurrency(parseFloat(props.item.price * props.item.amount).toFixed(2)) }}
            </span>
          </td>
        </tr>
      </template>
      <template v-slot:body.append="items" v-if="showFooter">
        <tr class="text-xs-left no-zebra">
          <td colspan="4"></td>
          <td :class="{'text-center':!isCalculation, 'text-right':isCalculation}">
            <strong>{{
              Object.values(items.items).reduce(
                (sum, item) => item.amount + sum,
                0
              ).toFixed(2)
            }}</strong>
          </td>
          <td class="text-sm-right"></td>
          <td class="text-sm-right">
            <strong class="text-no-wrap">{{
                formatCurrency(Object.values(items.items).reduce(
                (sum, item) =>
                  (
                    parseFloat(item.price * item.amount) + parseFloat(sum)
                  ).toFixed(2),
                0
              ))
            }}  </strong>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import ApplicabilityWindow from "@/components/common/ApplicabilityWindow";
import EditValueMenu from "@/components/common/EditValueMenu.vue";

export default {
  name: "MultiCartPartsTable",
  components: {EditValueMenu, ApplicabilityWindow },
  mixins: [CommonMixin],
  props: {
    isVisible: null,
    data: Array,
    id: String,
    height: String,
    showFooter: {
      type: Boolean,
      default: false,
    },
    isCalculation: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    priceMenu: {},
    priceTmp: null,
    /**
     * Used to set parameters of ApplicabilityWindow.
     */
    applicabilityWin: {
      partNumber: null,
      isVisible: false,
    },
  }),
  mounted() {},
  created() {},
  computed: {
    items() {
      return this.data;
    },
    defaultCart: {
      get() {
        return this.$store.getters["cart/defaultCart"];
      },
      set(val) {
        for (let i in this.carts) {
          if (parseInt(this.carts[i].id) === parseInt(this.defaultCartId)) {
            this.carts[i] = val;
          }
        }
      },
    },
  },
  methods: {
    cartItemUpdate(item) {
      this.$store
        .dispatch("cart/cartItemUpdate", {
          id: this.defaultCart.id,
          item: item,
        })
        .then((data) => {});
    },
    getStyleApplicable(val) {
      let res = JSON.parse(val);
      if (!this.defaultCart || !res || !this.defaultCart.order_check_status)
        return { color: this.$vuetify.theme.dark ? "light" : "black" };
      if (res.applicable === true) {
        return { color: "green" };
      }
      if (res.applicable === false) {
        return { color: "red" };
      }
    },
    getTextApplicable(val) {
      let res = JSON.parse(val);
      if (!this.defaultCart || !res || !this.defaultCart.order_check_status)
        return "";
      if (res.applicable === true) {
        return this.$t("viewOrdersForm.check_result_true");
      }
      if (res.applicable === false) {
        return this.$t("viewOrdersForm.check_result_false");
      }
    },
  },
};
</script>

<style lang="scss">
.theme--light {
  .multicarttable {
    thead {
      tr {
        th {
          background: #fafafc;
        }
      }
    }
    tbody {
      tr {
        td {
          background: #fafafc;
        }
      }
    }
    tbody {
      background: transparent;
    }
  }
}
</style>
